import { ActionTypes } from "../ActionType";

export const setLoginData = (payload) =>
    (dispatch) => {
        dispatch({
            type: ActionTypes.SET_PROFILE_DATA,
            payload
        });
    }

    export const setLogout = () =>
    (dispatch) => {
        dispatch({
            type: ActionTypes.SET_LOGOUT,
        });
    }